<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">search</i>
                        </div>
                        <h4 class="card-title ">Filtros</h4>
                    </div>
                    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger': validation.reference != null}">
                                        <label for="reference" class="bmd-label-floating">Data de referência</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="referenceDates"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.reference">
                                        </model-list-select>
                                        <label v-if="validation.reference != null" id="reference-error" class="error" for="reference">{{ validation.reference }}</label>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.date_at != null}">
                                        <label for="interval" class="bmd-label-floating">Intervalo</label>
                                        <date-picker
                                            range
                                            v-model="form.date_at"
                                            lang="pt-br"
                                            format="DD/MM/YYYY"
                                            placeholder="Escolha uma data"
                                            >
                                        </date-picker>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.branch_id != null}">
                                        <label for="branch_id" class="bmd-label-floating">Loja</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="branches"
                                            option-value="id"
                                            option-text="name"
                                            placeholder="Loja"
                                            v-model="form.branch_id">
                                        </model-list-select>
                                        <label v-if="validation.branch_id != null" id="branch_id-error" class="error" for="branch_id">{{ validation.branch_id }}</label>
                                    </div>
                                </div>

                            </div>
                            <div class="row">

                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.administrator_id != null}">
                                        <label for="administrator_id" class="bmd-label-floating">Administradora</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="administrators"
                                            option-value="id"
                                            option-text="name"
                                            placeholder="Administradora"
                                            v-model="form.administrator_id">
                                        </model-list-select>
                                        <label v-if="validation.administrator_id != null" id="administrator_id-error" class="error" for="administrator_id">{{ validation.administrator_id }}</label>
                                    </div>
                                </div>

                                <div class="col-md-4"></div>
                                <div class="col-md-4"></div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                            <button type="submit" class="btn btn-fill btn-rose">Gerar</button>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    export default {
        computed: {
            administrators: {
                get() {
                    return this.$store.state.administrators.itens;
                }
            },
            typesCommissions: {
                get() {
                    return this.$store.state.commissions.typeOfCommissions
                }
            },
            branches() {
                return this.$store.state.defaults.branches;
            }
        },
        data() {
            return {
                 validation: {
                    date_at: null,
                    branch_id : null,
                    reference : null,
                    installment : null,
                    administrator_id : null

                },
                form: {
                    administrator_id: null,
                    branch_id: null,
                    // installment : null,
                    reference: 'sale_at',
                    date_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                },
                referenceDates: [
                    { id : 'sale_at' , name : 'Data da Venda'},
                    { id : 'deployment_at' , name : 'Data Alocação'},
                    { id : 'due_at', name : 'Data de Vencimento (apenas parcelas pagas)'},
                    { id : 'due_at-all', name : 'Data de Vencimento (parcelas pagas e não pagas)'},
                    { id : 'pay_at'  , name : 'Data de Pagamento'},
                ],
            };
        },
        methods: {
            async getDataAdministrators() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('administrators/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getData();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            async getData() {
                 var self = this;
                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('commissions/typesOfcommissions');
                response.then(function () {
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            onReset() {
                this.form = {
                    administrator_id: null,
                    date_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    installment : null,
                    branch_id: null,
                    reference: 'sale_at',
                };
            },
            onSubmit() {
                var self = this;
                var valid = true;

                self.validation = {
                    date_at: null,
                    branch_id : null,
                    reference : null,
                    // installment : null,
                    administrator_id : null

                };

                if (self.form.reference == '') {
                    valid = false;
                    self.validation.reference = 'Informe a data de referência!';
                }

                // if (!self.form.installment) {
                //     valid = false;
                //     self.validation.installment = 'Favor informar a administradora desejada!';
                // }

                if (!self.form.date_at[0] || !self.form.date_at[1]) {
                    valid = false;
                    self.validation.date_at = 'Favor informar o intervalo desejado!';
                }

                // if (!self.form.branch_id) {
                //     valid = false;
                //     self.validation.branch_id = 'Informe a loja!';
                // }


                if (valid) {
                    var serialize = JSON.stringify(self.form);
                    console.log(self.form)

                    window.open("print-store-commission?form=" + serialize, '_blank');
                }
            }
        },
        created() {
            var self = this;
            self.getDataAdministrators();
        }
    }
</script>